import { render, staticRenderFns } from "./CubeOfCubes.vue?vue&type=template&id=3bc37737&lang=pug"
import script from "./CubeOfCubes.vue?vue&type=script&lang=js"
export * from "./CubeOfCubes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports